export default __webpack_public_path__ + "static/media/pin.42d71783.svg";